import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// A term's "how much it matters" control on the Neutral playbook: pick a level and it saves, no button.
// Sends only the level; the server keeps everything else about the term as it was.
export default class extends Controller {
    async save() {
        const form = this.element
        form.dataset.state = "saving"
        try {
            const response = await fetch(form.action, {
                method: "POST",
                body: new FormData(form),
                headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
                credentials: "same-origin"
            })
            const body = await response.json().catch(() => ({}))
            form.dataset.state = response.ok && body.ok ? "saved" : "error"
            if (form.dataset.state === "error") form.title = body.error || "That didn't save."
        } catch (_error) {
            form.dataset.state = "error"
            form.title = "That didn't save."
        }
    }
}
